import styles from 'styles/modules/mediaCoverage/Input.module.scss';
import { useState } from 'react';
import { profile } from 'lang/en.json';

const Input = (props) => {
    const [val, setVal] = useState(props.description || '');

    const handleChange = (e) => {
        setVal(e.target.value);

        if (props.callback) {
            props.callback(e.target.value);
        }
    };

    return (
        <div className={styles.description}>
            <label htmlFor="description" className={styles.descriptionLabel}>
                {profile.media_coverage.sidebar.link}
            </label>
            <textarea
                name="description"
                className={styles.descriptionTextarea}
                onChange={handleChange}
                value={val}
            />
        </div>
    );
};

export default Input;
